<template>
    <div class="flex flex-col gap-3 rounded-2xl border border-[#e2e8f0] bg-white px-5 py-4 md:flex-row md:items-center md:gap-4">
        <div class="flex-1 min-w-0">
            <p class="body-small-semibold text-valence-grey-900">Do you lead a team?</p>
            <p class="body-small text-valence-grey-600">Managers can track goals for themselves and for their team members</p>
        </div>
        <div class="flex items-center justify-end gap-4 md:shrink-0">
            <fieldset class="flex items-center gap-2">
                <legend class="sr-only">Do you lead a team?</legend>
                <label class="flex items-center gap-2 cursor-pointer rounded px-2 py-1.5 hover:bg-slate-50" for="manager-banner-yes">
                    <input id="manager-banner-yes" v-model="selectedValue" type="radio" value="yes" class="w-5 h-5" style="accent-color: #595959" />
                    <span class="body-small text-valence-grey-750">Yes</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer rounded px-2 py-1.5 hover:bg-slate-50" for="manager-banner-no">
                    <input id="manager-banner-no" v-model="selectedValue" type="radio" value="no" class="w-5 h-5" style="accent-color: #595959" />
                    <span class="body-small text-valence-grey-750">No</span>
                </label>
            </fieldset>
            <button
                class="shrink-0 rounded-full bg-valence-primary-200 hover:bg-valence-primary-300 text-valence-grey-750 body-small-semibold px-4 py-1.5 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                :disabled="!selectedValue || isSubmitting"
                @click="handleConfirm">
                {{ isSubmitting ? "Saving…" : "Confirm" }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import { computed, onMounted, ref } from "vue";

import { JourneysAmplitudeEventNames, logJourneysUserInteraction } from "./utils";

const emit = defineEmits<{ confirmed: [isManager: boolean] }>();

const selectedValue = ref<"yes" | "no" | null>(null);
const isSubmitting = ref(false);

onMounted(() => {
    logJourneysUserInteraction(JourneysAmplitudeEventNames.MANAGER_BANNER_SHOWN);
});

const { execute: saveManagerStatus } = useFetch("/api/accounts/user", { immediate: false })
    .put(computed(() => ({ is_manager: selectedValue.value === "yes" })))
    .json();

async function handleConfirm() {
    if (!selectedValue.value) {
        return;
    }
    isSubmitting.value = true;
    await saveManagerStatus();
    isSubmitting.value = false;
    const isManager = selectedValue.value === "yes";
    logJourneysUserInteraction(JourneysAmplitudeEventNames.MANAGER_BANNER_SUBMITTED, { is_manager: isManager });
    emit("confirmed", isManager);
}
</script>
